import React, {
  useContext,
  useRef,
  useState,
  useEffect,
  Suspense
} from "react";
import { Route, Routes, useParams, useNavigate } from "react-router-dom";
import "./assets/css/saira.css";
import "./App.css";
import { ThemeContext } from "./themecontext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  LoadScript
} from "@react-google-maps/api";
// import * as microsoftTeams from "@microsoft/teams-js";

import { media, app, pages } from "@microsoft/teams-js"; 
import Cookies from "js-cookie";
import redirectURL from "./components/redirectURL.js";
// import TVSComparisonPage from "./components/layout/comparison.js";

/* ------------------ LAZY IMPORTS ------------------ */
const NewUiSidebar = React.lazy(() =>
  import("./components/newui/newuisidebar")
);

const LoginPage = React.lazy(() =>
  import("./components/loginpage/LoginPage.js")
);

const RegistrationForm = React.lazy(() =>
  import("./components/loginpage/signuppage")
);

const UserManagement = React.lazy(() =>
  import("./components/loginpage/usermodule")
);

const TransitionPage = React.lazy(() =>
  import("./components/transitionpage/transitionpage.js")
);

const NewPage = React.lazy(() =>
  import("./components/newui/newpage")
);

const FlowContent = React.lazy(() =>
  import("./components/newui/flowcontent")
);

const ChatContent = React.lazy(() =>
  import("./components/newui/chatcontent")
);

const TvsChatContent = React.lazy(() =>
  import("./components/newui/tvsChatContent.js")
);

const Dashboard = React.lazy(() =>
  import("./components/dashboard/dashboard.js")
);

const EmptyDashboard = React.lazy(() =>
  import("./components/newui/emptydashboard.js")
);

const ShareChatPage = React.lazy(() =>
  import("./components/sharechatpage/ShareChatPage.js")
);

const URLLogin = React.lazy(() =>
  import("./components/loginpage/urllogin.js")
);

const VoiceAssistant = React.lazy(() =>
  import("./components/newui/toy.js")
);

const ProtectedRoute = React.lazy(() =>
  import("./protectedroute")
);

const TVSComparisonPage = React.lazy(() =>
  import("./components/layout/comparison.js")
);
const MaruthiFileComparison = React.lazy(() =>
  import("./components/layout/newcomparison.js")
);

const EnmUserLogin = React.lazy(() =>
  import("./components/loginpage/enmuserlogin")
);

/* ------------------ APP START ------------------ */

function App() {
  const [accessType, setAccessType] = useState("web");
  const [loading, setLoading] = useState(false);
  const [deviceType, setDeviceType] = useState(null);

  localStorage.setItem("access_type", "web");
  localStorage.setItem("access_origin_type", "web");

  /* ---- Teams Context Detection ---- */
  useEffect(() => {
    const fetchData = async () => {
      try {
        await app.initialize();
        app.notifySuccess();

        const context = await app.getContext();

        // Request mic permission (important for SpeechRecognition)
        // Request microphone permission (NEW SDK)
        try {
          const result = await media.selectMicrophone({
            allowFullDeviceList: true
          });
          console.log("Mic permission granted", result);
        } catch (err1) {
          console.warn("requestPermission failed, trying getMedia:", err1);

          //   try {
          //     await microsoftTeams.media.getMedia({
          //       audio: true,
          //       video: false
          //     });
          //     console.log("Mic access via getMedia");
          //   } catch (err2) {
          //     console.error("Microphone permission denied on both APIs:", err2);
          //   }
        }

        console.log("Teams context:", context);
        setAccessType("teams");

        // const userEmail =
        //   context.user?.userPrincipalName || context.user?.email;

        // if (userEmail) {
        //   localStorage.clear();
        //   localStorage.setItem("access_type", "teams");
        //   localStorage.setItem("teams_user_email", userEmail);
        //   localStorage.setItem("access_origin_type", "teams");
        // }
        // Extract email
        const userEmail = context.user?.userPrincipalName || context.user?.email;
        console.log("User email:", userEmail);

        if (userEmail) {
          localStorage.clear();
          localStorage.setItem("access_type", "teams");
          localStorage.setItem("teams_user_email", userEmail);
          localStorage.setItem("access_origin_type", "teams");
          if (context.app.host.clientType === "android" || context.app.host.clientType === "ios") {
            console.log("Website is in the Teams mobile app.");
            // localStorage.setItem("device_type", "mobile");
            localStorage.setItem("device_type", "mobile");
          }
        } else {
          console.warn(
            "Email is undefined. You might need to request additional permissions in Teams app manifest."
          );
        }

      } catch (err) {
        console.error("Teams init failed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   const getUserEmail = async () => {
  //     if (typeof window !== "undefined" && window.Office) {
  //       Office.onReady(async () => {
  //         console.log("Office is ready");
  //         try {
  //           const token = await OfficeRuntime.auth.getAccessToken({
  //             allowConsentPrompt: true,
  //             allowSignInPrompt: true,
  //           });

  //           if (token) {
  //             const parts = token.split(".");
  //             const payload = JSON.parse(atob(parts[1]));
  //             const userEmail = payload.preferred_username;

  //             console.log("User Email:", userEmail);

  //             setAccessType("excel");
  //             localStorage.clear();
  //             localStorage.setItem("access_type", "excel");
  //             localStorage.setItem("teams_user_email", userEmail);
  //             localStorage.setItem("access_origin_type", "excel");
  //           }
  //         } catch (err) {
  //           console.error("Failed to get email:", err);
  //           setAccessType("web");
  //         }
  //       });
  //     } else {
  //       console.log("Running outside Excel / Office client");
  //       setAccessType("web");
  //       localStorage.clear();
  //       localStorage.setItem("access_type", "web");
  //       localStorage.setItem("access_origin_type", "web");
  //     }
  //   };

  //   getUserEmail();
  // }, []);



  useEffect(() => {
    if (accessType) {
      if (accessType == "teams") {
        localStorage.setItem("access_type", "web");
        // localStorage.setItem("teams_user_email", userEmail);
        localStorage.setItem("access_origin_type", "teams");
      } else if (accessType == "excel") {
        localStorage.setItem("access_type", "web");
        // localStorage.setItem("teams_user_email", userEmail);
        localStorage.setItem("access_origin_type", "excel");
      }
      else {
        localStorage.setItem("access_type", "web");
        // localStorage.setItem("teams_user_email", userEmail);
        localStorage.setItem("access_origin_type", "web");
      }
    }
  }, [accessType])


  function getDeviceType() {
    const ua = navigator.userAgent || "";
    const width = window.innerWidth;

    // ✅ Detect Microsoft Teams
    const isTeams = /Teams/i.test(ua);

    // Teams mobile (both Android & iOS)
    const isTeamsMobile =
      isTeams && (/Android|iPhone|iPad|iPod/i.test(ua) || width <= 767);

    // Teams desktop app (Electron-based or Windows/Mac client)
    const isTeamsDesktop =
      isTeams && !isTeamsMobile && (/Electron|Windows|Macintosh/i.test(ua));

    if (isTeamsMobile) {
      return "mobile";
    } else if (isTeamsDesktop) {
      return "desktop";
    }

    // ✅ Normal mobile/tablet/desktop detection
    const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);

    if (isMobileUA && width <= 767) {
      return "mobile";
    } else if (width >= 768 && width < 1024) {
      return "tablet";
    }

    return "desktop";
  }


  useEffect(() => {
    const handleResize = () => {
      const type = getDeviceType();
      localStorage.setItem("device_type", type);
      setDeviceType(type);
    };

    handleResize(); // 👈 run on first render
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <ThemeContext.Consumer>
      {(context) => {
        return (
          <Suspense fallback={<div>Loading...</div>}>
            {!loading && (
              <Routes>
                <Route
                  path="/"
                  element={
                    ["teams", "excel"].includes(accessType) ? (
                      <TeamsLoginPage />
                    ) : (
                      <LoginPage />
                    )
                  }
                />

                <Route
                  path="/login"
                  element={
                    ["teams", "excel"].includes(accessType) ? (
                      <TeamsLoginPage />
                    ) : (
                      <LoginPage />
                    )
                  }
                />

                <Route
                  path="/enmuserlogin/:token/:route?"
                  element={<EnmUserLogin />}
                />

                <Route
                  path="/saira-signup"
                  element={<RegistrationForm />}
                />

                <Route
                  path="/create-user"
                  element={<UserManagement />}
                />

                <Route
                  path="/transition"
                  element={<TransitionPage />}
                />

                <Route
                  path="/new-page"
                  element={
                    <ProtectedRoute>
                      <LayoutWithSidebar>
                        <NewPage />
                      </LayoutWithSidebar>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/chat/:userId/:chatId/"
                  element={
                    <ProtectedRoute>
                      <LayoutWithSidebar>
                        <ChatWrapper />
                      </LayoutWithSidebar>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/dashboard/:userId/:dashboardId"
                  element={
                    <ProtectedRoute>
                      <LayoutWithSidebar>
                        <Dashboard />
                      </LayoutWithSidebar>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/nodashboard"
                  element={
                    <ProtectedRoute>
                      <LayoutWithSidebar>
                        <EmptyDashboard />
                      </LayoutWithSidebar>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/share/:userId/:chatId/:organization"
                  element={
                    <LayoutWithoutSidebar>
                      <ShareChatPage />
                    </LayoutWithoutSidebar>
                  }
                />

                <Route
                  path="/prologin/:token"
                  element={<URLLogin />}
                />

                <Route
                  path="/file-comparison"
                  element={
                    <LayoutWithoutSidebar>
                      <TVSComparisonPage />
                    </LayoutWithoutSidebar>
                  }
                />

                <Route
                  path="/file-analyzer"
                  element={
                    <LayoutWithoutSidebar>
                      <MaruthiFileComparison />
                    </LayoutWithoutSidebar>
                  }
                />

                <Route
                  path="/epod-analyzer"
                  element={
                    <LayoutWithoutSidebar>
                      <VoiceAssistant />
                    </LayoutWithoutSidebar>
                  }
                />

                <Route
                  path="/copilotcomponent/:id"
                  element={
                    <LayoutWithoutSidebar>
                      <VoiceAssistant />
                    </LayoutWithoutSidebar>
                  }
                />

                <Route path="*" element={<ErrorWrapper />} />
              </Routes>
            )}
          </Suspense>
        );
      }}
    </ThemeContext.Consumer>
  );
}

/* ------------------ ERROR PAGE ------------------ */
const ErrorWrapper = () => (
  <div>
    <h2>404 - Not Found</h2>
    <p>Sorry, the page you requested does not exist.</p>
  </div>
);


function ChatWrapper() {
  const { chatId } = useParams();

  const org = localStorage.getItem("organization");

  if (org === "Automation") {
    return <FlowContent key={chatId} />;
  }

  if (org === "Document Analyzer AI") {
    return <TvsChatContent key={chatId} />;
  }

  return <ChatContent key={chatId} />;
}



/* ------------------ LAYOUTS ------------------ */
const LayoutWithSidebar = ({ children }) => {
  const { toggleSidebar } = useContext(ThemeContext);
  const contentRef = useRef(null);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="d-flex flex-row vw-100 vh-100">

        <Suspense fallback={<div>
          {/* Loading Menu... */}
        </div>}>
          <NewUiSidebar />
        </Suspense>

        <LoadScript googleMapsApiKey=
          "AIzaSyAFPrTim3Vp0jy9DYTyhB8uddAmoKGLf4c"
        // "AIzaSyBe_8Y6oHnMao6KiW4coNCthEJR5PvMNFM"
        >
          <div
            className="flex-grow-1 vh-100"
            ref={contentRef}
            style={{
              backgroundColor: "#fff",
              maxWidth: window.innerWidth,
              overflowX: "hidden"
            }}
          >
            {children}
          </div>
        </LoadScript>
      </div>
    </DndProvider>
  );
};

const LayoutWithoutSidebar = ({ children }) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <LoadScript googleMapsApiKey=
        "AIzaSyAFPrTim3Vp0jy9DYTyhB8uddAmoKGLf4c"
      // "AIzaSyBe_8Y6oHnMao6KiW4coNCthEJR5PvMNFM"
      >
        <div
          className="flex-grow-1 vh-100"
          style={{
            backgroundColor: "#fff",
            maxWidth: window.innerWidth,
            overflowX: "hidden"
          }}
        >
          {children}
        </div>
      </LoadScript>
    </DndProvider>
  );
};

/* ------------------ TEAMS LOGIN PAGE ------------------ */
const TeamsLoginPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("")
  const logPageLocation = async (check) => {
    try {
      var params = {
        ...check,
        email: localStorage.getItem("email")
      }
      const response = await redirectURL.post("/api/logPageLocation", params);
      if (response.data.status == "success") {

      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        var query = {
          email: localStorage.getItem("teams_user_email") ?? ""
        }
        // setError(JSON.parse(localStorage.getItem("teams_user_email")).userPrincipalName ?? "wery")
        var response = await redirectURL.post("/users/teamsLogin", query)
        // setError(JSON.stringify(response.data.user_details))
        if (response.data.status == "success") {
          var userDetails = response.data.user_details
          localStorage.setItem("email", userDetails.email)
          localStorage.setItem("userId", userDetails.user_id)
          localStorage.setItem("userType", userDetails.role)
          localStorage.setItem("organizationArray", userDetails.organization)
          localStorage.setItem('token', btoa(userDetails.user_id));

          Cookies.set('myCookie', userDetails.user_id, { expires: 1 });
          Cookies.set('token', btoa(userDetails.user_id), { expires: 1 });
          localStorage.setItem("customer", userDetails.customer)
          localStorage.setItem('checkIdea', false);
          try {
            var params = {
              email: localStorage.getItem("email")
            }
            const response = await redirectURL.post("/api/getPageLocation", params);
            if (response.data.status == "success") {
              if (response.data.result.length > 0) {
                var object = response.data.result[0]
                if (object?.current_organization) {
                  localStorage.setItem("organization", object.current_organization)
                  // await logPageLocation({ current_organization: object.current_organization, current_tab: ", current_chat_type: 1});
                  navigate("/new-page")
                  return
                }
              }
              navigate("/transition")
            }
          } catch (error) {
            console.log(error)
          }
          navigate("/transition")
          // setError("hello")
        }
      } catch (error) {
        console.log(error)
        //  setError(error)
      }
    }
    fetchData()
  }, [])
  return (
    <p>We are setting things for you</p>
  )
}



export default App;